import React, { useState, useEffect, useRef, useCallback } from "react";

export default function CityNotesPanel({ city, onClose, onEdit }) {
    const [pos, setPos] = useState({ left: 20, top: 60 });
    const [size, setSize] = useState({ width: 400, height: 500 });
    const dragging = useRef(null);
    const resizing = useRef(null);
    const panelRef = useRef(null);

    const onMouseMove = useCallback((e) => {
        if (dragging.current) {
            setPos({
                left: e.clientX - dragging.current.offsetX,
                top: e.clientY - dragging.current.offsetY,
            });
        }
        if (resizing.current) {
            const rect = resizing.current;
            setSize({
                width: Math.max(300, e.clientX - rect.startLeft),
                height: Math.max(200, e.clientY - rect.startTop),
            });
        }
    }, []);

    const onMouseUp = useCallback(() => {
        dragging.current = null;
        resizing.current = null;
    }, []);

    useEffect(() => {
        window.addEventListener("mousemove", onMouseMove);
        window.addEventListener("mouseup", onMouseUp);
        return () => {
            window.removeEventListener("mousemove", onMouseMove);
            window.removeEventListener("mouseup", onMouseUp);
        };
    }, [onMouseMove, onMouseUp]);

    const onHeaderMouseDown = (e) => {
        if (e.target.tagName === "BUTTON") return;
        dragging.current = {
            offsetX: e.clientX - pos.left,
            offsetY: e.clientY - pos.top,
        };
    };

    const onResizeMouseDown = (e) => {
        e.preventDefault();
        resizing.current = {
            startLeft: pos.left,
            startTop: pos.top,
        };
    };

    return (
        <div
            ref={panelRef}
            className="city-notes-panel"
            style={{
                left: pos.left,
                top: pos.top,
                width: size.width,
                height: size.height,
            }}
        >
            <div className="city-notes-header" onMouseDown={onHeaderMouseDown}>
                <span className="city-notes-title">{city.name}</span>
                <div className="city-notes-header-buttons">
                    {onEdit && (
                        <button onClick={() => onEdit(city)} title="Edit city">
                            &#9998;
                        </button>
                    )}
                    <button onClick={onClose} title="Close">
                        &#10005;
                    </button>
                </div>
            </div>
            <iframe
                className="city-notes-iframe"
                src={`/notes/Cities/${encodeURIComponent(city.name)}`}
                title={`Notes for ${city.name}`}
            />
            <div className="city-notes-resize" onMouseDown={onResizeMouseDown} />
        </div>
    );
}
